import { Component, OnInit, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { ApiService } from "src/app/services/api.service";
import { UtilserviceService } from "src/app/services/utilservice.service";
import { jhcassoAPIUri } from "src/environments/apiUri";

@Component({
  selector: "app-add-review",
  templateUrl: "./add-review.page.html",
  styleUrls: ["./add-review.page.scss"],
})
export class AddReviewPage implements OnInit {
  @Input() booking_id: any;
  @Input() salon_id: any;
  message = "";
  profilee: any;
  language: any;
  constructor(
    private modal: ModalController,
    private api: ApiService,
    private util: UtilserviceService
  ) { }
  ratingValue: any = 1;
  ngOnInit() {
    
    this.api.get(jhcassoAPIUri.profile).subscribe(
      (response: any) => {
        if (response.status) {
          this.profilee = response.data;
          
        }
      },
      (error) => {
        // 
      }
    );
    this.language = localStorage.getItem("lan");
  }
  close() {
    
    const data = {
      salon_id: this.salon_id,
      message: this.message,
      rate: this.ratingValue,
      booking_id: this.booking_id,
    };
    this.api.postDataWithToken(jhcassoAPIUri.review, data, 'V1').subscribe(
      async (success: any) => {
        if (success.success) {
          this.modal.dismiss(this.booking_id);
          if (this.language == "en") {
            this.util.presentToast("Review Added Successfullly");
          } else if (this.language == "ar") {
            this.util.presentToast("تمت إضافة المراجعة بنجاح");
          } else {
            this.util.presentToast("Recenzie adăugată cu succes");
          }
          
        }
      },
      (err) => {
        if (this.language == "en") {
          this.util.presentToast("Something went wrong ..!");
        } else if (this.language == "ar") {
          this.util.presentToast("هناك خطأ ما ..!");
        } else {
          this.util.presentToast("Ceva n-a mers bine ..!");
        }
        this.modal.dismiss();
      }
    );
  }

  setRating(val) {
    this.ratingValue = val;
  }
}
